import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import { celebMustHave } from '../services/General-service';

function Celebratory({ showmusthave, sectionTitle }) {
    const [categoryArr, setCategoryArr] = useState([]);
    const slidesToShow = 5;
    // Slick only animates the arrow click when there are more slides than are visible.
    const slides = categoryArr.length > slidesToShow
        ? categoryArr
        : categoryArr.length
            ? Array.from(
                { length: Math.ceil((slidesToShow + 1) / categoryArr.length) },
                () => categoryArr
            ).flat()
            : [];
    const canSlide = slides.length > slidesToShow;

    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        cssEase: "ease",
        useCSS: true,
        slidesToShow: Math.min(slidesToShow, slides.length || 1),
        slidesToScroll: canSlide ? slidesToShow : 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(slidesToShow, slides.length || 1),
                    slidesToScroll: canSlide ? slidesToShow : 1,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: Math.min(2, slides.length || 1),
                    slidesToScroll: slides.length > 2 ? 2 : 1,
                    infinite: false,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: Math.min(2, slides.length || 1),
                    slidesToScroll: slides.length > 2 ? 2 : 1,
                    infinite: false
                }
            }
        ]
    };

    useEffect(() => {
        celebMustHave({ limit: 100 })
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                setCategoryArr(list);
            })
            .catch((error) => {
                console.error("Error fetching shop by category:", error);
            });
    }, []);

    return (
        showmusthave && categoryArr.length > 0 && (
            <div>
                <div className='App'>
                    <div className="BreakPointContainer">
                        <div className="CarouselSectionContainer shop-the-look shop-by-category">
                            <div className="layout row justify-space-between align-center text-left SectionTitle">
                                <h1 className='m-t-0 m-b-0 demi-bold w-auto'> {sectionTitle || 'SHOP BY CATEGORY'} </h1>
                                <Link to="/category" className='ViewAllUrlsLink orat-color-hover h5 demi-bold w-auto'>VIEW ALL</Link>
                            </div>
                            <div className="layout">
                                <div className="flex left-align-slick xs12">
                                    <Slider {...settings}>
                                        {slides.map((data, index) => (
                                            <div className='item sjl' key={`${data.id || 'cat'}-${index}`}>
                                                <div className="CarouselSection category">
                                                    <div className="prel Gutter">
                                                        <Link to={`/category/?category_ids=${data.id}`}>
                                                            <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '112%' }}>
                                                                <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '32%' }}>
                                                                    <img src={data.thumbnail} alt={data.title} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px' }} />
                                                                </div>
                                                            </div>
                                                            <div className="ImageTextDetail CategoryImageTextDetail">
                                                                <label className="h4 ImageTextLabelTop m-t-5 demi-bold"> {data.title} </label>
                                                                <label className="h6 ellipsis ImageTextLabelBottom block font-normal">SHOP NOW</label>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
}

export default Celebratory;
